import React from 'react';
import { Helmet } from 'react-helmet';

import MainContainer from '../components/cadastre/main';
import Layout from '../components/layout/index';
import SEO from '../components/seo';

const CadastroPage = () => {
  return (
    <Layout internal={true} hasChatButton={true}>
      <SEO title="Cadastre-se" />
      <Helmet>
        <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/50821833.js" />
      </Helmet>
      <MainContainer />
    </Layout>
  );
};

export default CadastroPage;
